export default {
    data: function () {
        return {
            pickerOptions: {
                shortcuts: [
                    {
                        text: this.$l10n.__('Semaine dernière'),
                        value: () => {
                            const start = new moment().startOf('week').subtract(1, 'weeks');
                            const end = new moment().endOf('week').subtract(1, 'weeks');
                            return [start.toDate(), end.toDate()];
                        },
                    },
                    {
                        text: this.$l10n.__('De ce mois'),
                        value: () => {
                            const start = new moment().startOf('month');
                            const end = new moment().endOf('month');
                            return [start.toDate(), end.toDate()];
                        },
                    },
                    {
                        text: this.$l10n.__('Du mois dernier'),
                        value: () => {
                            const start = new moment().subtract(1, 'months').startOf('month');
                            const end = new moment().subtract(1, 'months').endOf('month');
                            return [start.toDate(), end.toDate()];
                        },
                    },
                    {
                        text: this.$l10n.__('Des 3 derniers mois'),
                        value: () => {
                            const start = new moment().subtract(3, 'months').startOf('month');
                            const end = new moment().subtract(1, 'months').endOf('month');
                            return [start.toDate(), end.toDate()];
                        },
                    },
                    {
                        text: this.$l10n.__("De l'année en cours"),
                        value: () => {
                            const start = new moment().startOf('year');
                            const end = new moment().endOf('year');
                            return [start.toDate(), end.toDate()];
                        },
                    },
                    {
                        text: this.$l10n.__("De l'année dernière"),
                        value: () => {
                            const start = new moment().startOf('year').subtract(1, 'years');
                            const end = new moment().endOf('year').subtract(1, 'years');
                            return [start.toDate(), end.toDate()];
                        },
                    },
                ],
            },
        };
    },
};
